import { Reveal } from "./Reveal";

export function SectionHeading({ chapter, overline, title, sub, dark = false, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
          {chapter && (
            <span className={`font-display text-sm italic ${dark ? "text-gold" : "text-gold"}`}>
              {chapter}
            </span>
          )}
          <span className="h-px w-10 bg-gold/70" />
          <span className={`text-xs uppercase tracking-[0.25em] font-bold ${dark ? "text-gold-soft" : "text-teal-brand"}`}>
            {overline}
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className={`mt-5 font-display text-3xl md:text-4xl lg:text-5xl leading-[1.12] tracking-tight font-medium text-balance ${dark ? "text-ivory" : "text-pine-deep"}`}>
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-ivory/70" : "text-slate-600"}`}>
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
